import React from "react";

const AmbassadorRequest = ({ data = [], onApprove, onReject, onCancel }) => {
  return (
    <div className="premium-user-list-wrapper">
      <div className="premium-scroll-container">
        {data?.map((item, index) => {
          const isPending = item.status === "PENDING";
          const isApproved = item.status === "APPROVED";
          const isRejected = item.status === "REJECTED";
          const isCancelled = item.status === "CANCELLED";

          return (
            <div key={item._id || index} className="premium-table-row">
              {/* USER */}
              <div style={{ width: "22%" }} className="plan-cell">
                <div className="plan-info">
                  <div className="user-box">
                    <img
                      src={item.userId?.profileImageURL || "/default-avatar.png"}
                      alt="user"
                      className="user-avatar"
                    />
                    <div>
                      <div className="plan-title">
                        {item.userId?.name || "Unknown User"}
                      </div>
                      <div className="plan-desc">
                        {item.userId?.email || "No email"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* PLAN */}
              <div style={{ width: "20%" }} className="plan-desc">
                {item.planId?.title || "Unknown Plan"}
                {item.planId?.type === "AMBASSADOR" && (
                  <div style={{ fontSize: "10px", color: "#94a3b8", marginTop: "2px" }}>
                    Ambassador Plan
                  </div>
                )}
              </div>

              {/* STATUS */}
              <div style={{ width: "18%" }}>
                <span className={`status-badge ${item.status.toLowerCase()}`}>
                  {item.status}
                </span>

                {isRejected && item.adminNote && (
                  <div
                    title={item.adminNote}
                    style={{
                      color: "#f87171",
                      fontSize: "11px",
                      marginTop: "8px",
                      lineHeight: "14px",
                      paddingRight: "15px",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      whiteSpace: "normal",
                    }}
                  >
                    {item.adminNote}
                  </div>
                )}

                {isApproved && item.approvedSubscriptionId && (
                  <div
                    style={{
                      color: "#22c55e",
                      fontSize: "10px",
                      marginTop: "4px",
                    }}
                  >
                    ✅ Active
                  </div>
                )}
              </div>

              {/* DATE */}
              <div style={{ width: "20%" }} className="plan-desc">
                {new Date(item.createdAt).toLocaleDateString()}
                {item.reviewedAt && (
                  <div style={{ fontSize: "10px", color: "#94a3b8" }}>
                    Reviewed: {new Date(item.reviewedAt).toLocaleDateString()}
                  </div>
                )}
              </div>

              {/* ACTION */}
              <div style={{ width: "20%", display: "flex", gap: "10px", flexWrap: "wrap" }}>
                {isPending ? (
                  <>
                    <button
                      className="approve-btn"
                      onClick={() => onApprove(item)}
                    >
                      Approve
                    </button>
                    <button
                      className="reject-btn"
                      onClick={() => onReject(item)}
                    >
                      Reject
                    </button>
                  </>
                ) : isApproved ? (
                  <button
                    className="cancel-btn"
                    onClick={() => onCancel(item)}
                  >
                    Cancel Access
                  </button>
                ) : isRejected ? (
                  <span className="done-text rejected-text">Rejected</span>
                ) : isCancelled ? (
                  <span className="done-text cancelled-text">Cancelled</span>
                ) : (
                  <span className="done-text">Completed</span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <style jsx>{`
        .premium-table-row {
          display: flex;
          padding: 18px 16px;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          align-items: center;
        }

        .premium-table-row:hover {
          background: rgba(255,255,255,0.02);
        }

        .plan-title {
          color: #fff;
          font-weight: 600;
          font-size: 14px;
        }

        .plan-desc {
          color: #cbd5f5;
          font-size: 13px;
        }

        .status-badge {
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
          display: inline-block;
        }

        .status-badge.pending {
          background: rgba(245, 158, 11, 0.2);
          color: #f59e0b;
        }

        .status-badge.approved {
          background: rgba(34, 197, 94, 0.2);
          color: #22c55e;
        }

        .status-badge.rejected {
          background: rgba(239, 68, 68, 0.2);
          color: #ef4444;
        }

        .status-badge.cancelled {
          background: rgba(148, 163, 184, 0.2);
          color: #94a3b8;
        }

        .approve-btn {
          background: #22c55e;
          color: #fff;
          border: none;
          padding: 6px 16px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
          font-weight: 500;
          transition: all 0.3s;
        }

        .approve-btn:hover {
          background: #16a34a;
          transform: scale(1.02);
        }

        .reject-btn {
          background: #ef4444;
          color: #fff;
          border: none;
          padding: 6px 16px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
          font-weight: 500;
          transition: all 0.3s;
        }

        .reject-btn:hover {
          background: #dc2626;
          transform: scale(1.02);
        }

        .cancel-btn {
          background: #f59e0b;
          color: #fff;
          border: none;
          padding: 6px 16px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
        }

        .cancel-btn:hover {
          background: #d97706;
          transform: scale(1.02);
        }

        .done-text {
          color: #94a3b8;
          font-size: 13px;
          font-weight: 500;
          padding: 6px 0;
        }

        .rejected-text {
          color: #ef4444;
        }

        .cancelled-text {
          color: #94a3b8;
        }

        .user-box {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid rgba(255,255,255,0.1);
        }

        .plan-cell {
          display: flex;
          align-items: center;
        }

        .plan-info {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        @media (max-width: 768px) {
          .premium-table-row {
            flex-wrap: wrap;
            gap: 8px;
          }
          
          .premium-table-row > div {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default React.memo(AmbassadorRequest);